import { Box } from '@cdl/heartbeat-react';
import React from 'react';
import { hasILRImage, useILRImage } from '../utils/ilr.utils';

interface Props {
  ecgId: string;
}

export const ILRImagePlot: React.FC<Props> = ({ ecgId }) => {
  const image = useILRImage(ecgId);

  if (!hasILRImage(image)) {
    return null;
  }

  return (
    <Box borderRadius='0.25rem'>
      <img style={{ maxWidth: '100%' }} src={image.data} alt='ilr plot' />
    </Box>
  );
};
